// User Reducer
import {
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  GET_USERS_RESET,
  GET_USER_BY_ID,
  GET_USER_BY_ID_SUCCESS,
  GET_USER_BY_ID_FAIL,
  GET_USER_BY_ID_RESET,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  CREATE_USER_RESET,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_USER_RESET,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  DELETE_USER_RESET,
  GET_SHAREABLE_USERS,
  GET_SHAREABLE_USERS_SUCCESS,
  GET_SHAREABLE_USERS_FAIL,
  GET_SHAREABLE_USERS_RESET,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_RESET,
  RESEND_INVITATION,
  RESEND_INVITATION_SUCCESS,
  RESEND_INVITATION_FAIL,
  RESEND_INVITATION_RESET,
  ADMIN_RESET_PASSWORD,
  ADMIN_RESET_PASSWORD_SUCCESS,
  ADMIN_RESET_PASSWORD_FAIL,
  ADMIN_RESET_PASSWORD_RESET,
} from '../actions/userAction';

const initialState = {
  // Get Users
  getUsersState: {
    apiState: 'idle', // idle, loading, success, error
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Get User By ID
  getUserByIdState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Create User
  createUserState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Update User
  updateUserState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Delete User
  deleteUserState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Shareable Users
  getShareableUsersState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Change Password
  changePasswordState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Resend Invitation
  resendInvitationState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  // Admin Reset Password (super-admin force reset)
  adminResetPasswordState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Users
    case GET_USERS:
      return {
        ...state,
        getUsersState: {
          ...state.getUsersState,
          apiState: 'loading',
        },
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        getUsersState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Users retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_USERS_FAIL:
      return {
        ...state,
        getUsersState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch users',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_USERS_RESET:
      return {
        ...state,
        getUsersState: initialState.getUsersState,
      };

    // Get User By ID
    case GET_USER_BY_ID:
      return {
        ...state,
        getUserByIdState: {
          ...state.getUserByIdState,
          apiState: 'loading',
        },
      };
    case GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        getUserByIdState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'User retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_USER_BY_ID_FAIL:
      return {
        ...state,
        getUserByIdState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch user',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_USER_BY_ID_RESET:
      return {
        ...state,
        getUserByIdState: initialState.getUserByIdState,
      };

    // Create User
    case CREATE_USER:
      return {
        ...state,
        createUserState: {
          ...state.createUserState,
          apiState: 'loading',
        },
      };
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        createUserState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'User created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_USER_FAIL:
      return {
        ...state,
        createUserState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create user',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_USER_RESET:
      return {
        ...state,
        createUserState: initialState.createUserState,
      };

    // Update User
    case UPDATE_USER:
      return {
        ...state,
        updateUserState: {
          ...state.updateUserState,
          apiState: 'loading',
        },
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        updateUserState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'User updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_USER_FAIL:
      return {
        ...state,
        updateUserState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update user',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_USER_RESET:
      return {
        ...state,
        updateUserState: initialState.updateUserState,
      };

    // Delete User
    case DELETE_USER:
      return {
        ...state,
        deleteUserState: {
          ...state.deleteUserState,
          apiState: 'loading',
        },
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        deleteUserState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'User deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_USER_FAIL:
      return {
        ...state,
        deleteUserState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete user',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_USER_RESET:
      return {
        ...state,
        deleteUserState: initialState.deleteUserState,
      };

    // Shareable Users
    case GET_SHAREABLE_USERS:
      return {
        ...state,
        getShareableUsersState: {
          ...state.getShareableUsersState,
          apiState: 'loading',
        },
      };
    case GET_SHAREABLE_USERS_SUCCESS:
      return {
        ...state,
        getShareableUsersState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Shareable users retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_SHAREABLE_USERS_FAIL:
      return {
        ...state,
        getShareableUsersState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch shareable users',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_SHAREABLE_USERS_RESET:
      return {
        ...state,
        getShareableUsersState: initialState.getShareableUsersState,
      };

    // Change Password
    case CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordState: {
          ...state.changePasswordState,
          apiState: 'loading',
        },
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Password changed successfully',
          errors: action.response.errors || null,
        },
      };
    case CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        changePasswordState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to change password',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CHANGE_PASSWORD_RESET:
      return {
        ...state,
        changePasswordState: initialState.changePasswordState,
      };

    // Resend Invitation
    case RESEND_INVITATION:
      return {
        ...state,
        resendInvitationState: {
          ...state.resendInvitationState,
          apiState: 'loading',
        },
      };
    case RESEND_INVITATION_SUCCESS:
      return {
        ...state,
        resendInvitationState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Invitation resent successfully',
          errors: action.response.errors || null,
        },
      };
    case RESEND_INVITATION_FAIL:
      return {
        ...state,
        resendInvitationState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to resend invitation',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case RESEND_INVITATION_RESET:
      return {
        ...state,
        resendInvitationState: initialState.resendInvitationState,
      };

    // Admin Reset Password (super-admin force reset)
    case ADMIN_RESET_PASSWORD:
      return {
        ...state,
        adminResetPasswordState: {
          ...state.adminResetPasswordState,
          apiState: 'loading',
        },
      };
    case ADMIN_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        adminResetPasswordState: {
          apiState: 'success',
          data: action.response.data || action.response,
          message: action.response.message || 'Password reset successfully',
          errors: action.response.errors || null,
        },
      };
    case ADMIN_RESET_PASSWORD_FAIL:
      return {
        ...state,
        adminResetPasswordState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to reset password',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case ADMIN_RESET_PASSWORD_RESET:
      return {
        ...state,
        adminResetPasswordState: initialState.adminResetPasswordState,
      };

    default:
      return state;
  }
};

export default userReducer;

